import { useState } from 'react'

// write hook to reload preview take an action to reload the preview

export const useReloadPreview = () => {
    const [reloadPreview, setReloadPreview] = useState(false)
    const reloadPreviewAction = () => {
        setReloadPreview(true)
    }
    return [reloadPreview, reloadPreviewAction]
}